"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var fullHeight = props.fullHeight;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    basicFontSize = _useContext.basicFontSize,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    getMeasurement = _useStylesUtils.getMeasurement;
  var ccAudiencePickerSingleStudentsStyle = (0, _react.useMemo)(function () {
    var deviceProps = function deviceProps() {
      var height = isMobileView ? pxToRem(48) : pxToRem(80);
      var paddingBottom = isMobileView ? 0 : pxToRem(20);
      return {
        height: height,
        paddingBottom: paddingBottom
      };
    };
    var searchDeviceProps = function searchDeviceProps() {
      var paddingTop = isMobileView ? pxToRem(8) : pxToRem(20);
      var height = isMobileView ? pxToRem(64) : pxToRem(68);
      return {
        paddingTop: paddingTop,
        height: height
      };
    };
    var ccAudiencePickerFullItem = (0, _css.css)({
      height: isMobileView ? '100%' : fullHeight ? getMeasurement(fullHeight) : 'auto',
      display: 'flex',
      flexDirection: 'column'
    });
    var ccAudiencePickerSingleStudentsTitle = (0, _css.css)({
      fontSize: pxToRem(26),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.dark,
      margin: 0,
      marginBottom: pxToRem(5),
      lineHeight: 1.05
    });
    var ccAudiencePickerSingleStudents = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      paddingTop: pxToRem(3)
    });
    var ccAudiencePickerSingleStudentsHeader = (0, _css.css)(_objectSpread({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: pxToRem(16)
    }, deviceProps()));
    var ccAudiencePickerSingleStudentsHeaderSelectTitle = (0, _css.css)({
      fontSize: basicFontSize,
      fontWeight: 'bold',
      paddingInlineStart: pxToRem(12),
      paddingBottom: pxToRem(8)
    });
    var ccAudiencePickerSingleStudentsHeaderSearch = (0, _css.css)(_objectSpread({
      flexGrow: 1
    }, searchDeviceProps()));
    return {
      ccAudiencePickerFullItem: ccAudiencePickerFullItem,
      ccAudiencePickerSingleStudents: ccAudiencePickerSingleStudents,
      ccAudiencePickerSingleStudentsTitle: ccAudiencePickerSingleStudentsTitle,
      ccAudiencePickerSingleStudentsHeader: ccAudiencePickerSingleStudentsHeader,
      ccAudiencePickerSingleStudentsHeaderSelectTitle: ccAudiencePickerSingleStudentsHeaderSelectTitle,
      ccAudiencePickerSingleStudentsHeaderSearch: ccAudiencePickerSingleStudentsHeaderSearch
    };
  }, [basicFontSize, fullHeight, getMeasurement, isMobileView, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.dark]);
  return {
    'cc-AudiencePicker__full-item': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerFullItem,
    'cc-AudiencePicker__single-students': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerSingleStudents,
    'cc-AudiencePicker__single-students__title': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerSingleStudentsTitle,
    'cc-AudiencePicker__single-students__header': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerSingleStudentsHeader,
    'cc-AudiencePicker__single-students__header__select-title': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerSingleStudentsHeaderSelectTitle,
    'cc-AudiencePicker__single-students__header__search': ccAudiencePickerSingleStudentsStyle.ccAudiencePickerSingleStudentsHeaderSearch
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;